import { Component, OnInit, ViewContainerRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { CopyComponentListVM, CopyImplmentVM, CopyObservationListVM, ImplementToCopy, ListOfComponetInfo } from '../setup-implement/copy-implement-dialog/copy-implement-dialog.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
import { GenericIdName, SetupImplementErrorCodes, SaveImplementDetailParams, ImplementDetails, GenericIdNameBudgetHours } from '../setup-implement/setup-implement.model';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { AppService } from '../../../app.service';
import { FrontEndComponetService } from '../FECR/front-end-componet.service';
import { ImplementItem } from '../FECR/FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { NotificationsService } from 'angular2-notifications';
import { ImplementDetailsService } from '../implement-details/implement-details.service';
import { DateAdapter } from '@angular/material/core';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'app-copy-implment-advanced',
  templateUrl: './copy-implment-advanced.component.html',
  styleUrls: ['./copy-implment-advanced.component.scss']
})
export class CopyImplmentAdvancedComponent implements OnInit {
  displayedColumns = [
    'selectImplement', 'implementTypeAndSerial', 'implementType', 'newSerialNo',
    'setupDate', 'implementHoursAtSetup', 'equipmentSMUAtSetup', 'budget_hoursAtSetup', 'Purchased_CostAtSetup', 'status'];
  dataSource = new MatTableDataSource<ImplementToCopy>();


  // User selected parameters
  destEquipment: number = 0;
  destJobsite: number = 0;
  //source
  equipmentOrInventory: number = 1;
  customerList: CustomerSelectItem[] = [];
  jobsiteList: JobsiteSelectItem[] = [];
  equipmentList: EquipmentSelectItem[] = [];
  implementList: GenericIdNameBudgetHours[] = [];

  //destination
  destinationequipmentOrInventory: number = 1;
  destinationCustomer: number;
  destinationJobsite: number;
  destinationEquipment: number;
  destinationImplementType: number;
  destinationImplement: number;
  destinationcustomerList: CustomerSelectItem[] = [];
  destinationjobsiteList: JobsiteSelectItem[] = [];
  destinationequipmentList: EquipmentSelectItem[] = [];
  destinationimplementList: ImplementItem[] = [];
  destinationImplementTypsList: GenericIdName[] = [];
  CopydestinationimplementList: ImplementItem[] = [];




  //model mot match err
  model_match_for_source_desti_eq: boolean = true;
  source_eq_model: string;
  desti_eq_model: string


  // User selections in input boxes
  selectedCustomer: number;
  selectedJobsite: number;
  selectedEquipment: number = 0;
  isCopy: boolean = false;
  // Error codes
  pageErrors: SetupImplementErrorCodes = new SetupImplementErrorCodes();

  equipmentSMU: number = 0;

  //TT-6464

  MultipleComponentsInfo: ListOfComponetInfo[] = [];
  //TT-4980
  componentList: CopyComponentListVM[] = [];
  observationList: CopyObservationListVM[] = [];

  dataSourceComponentList = new MatTableDataSource<CopyComponentListVM>();

  routeImplementId: number;
  routeImplementTypeId: number

  implementTypeList: GenericIdName[];

  DestinationTemplateImplementTypeId: number;

  IsSchematicUsedLink: number = 2;
  source: string = '';
  copyId: number = 0;
  copiedComponentId: any[] = [];
  constructor(
    private _equipmentService: GETSetupEquipmentService,
    private _implementService: SetupImplementService, private _fecrService: FrontEndComponetService,
    public toastr: NotificationsService, vcr: ViewContainerRef, private _router: Router,
    private _appService: AppService,
    private dateAdapter: DateAdapter<Date>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    private _implementDetailService: ImplementDetailsService,
    private cdr: ChangeDetectorRef) {

    this.dateAdapter.setLocale('en-GB');
  }

  ngOnInit() {
    this._appService.setPageTitle('Copy Implement Setup');
    //this._appService.setPageSubTitle('');
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      this.destinationcustomerList = r;
    })
    this.loadImplementsList();
    this.LoadImplementTypes_();
    this.route.params.subscribe(params => {
      this.routeImplementId = +params['implementId'];
      if (this.routeImplementId) {
        this._implementService.GetImplementDetails(this.routeImplementId).subscribe(res => {
          this.destinationequipmentOrInventory = 3
          this.destinationCustomer = res.CustomerId;
          this.routeImplementTypeId = res.ImplementType;
          this.copyId = res.CopyFromId;
          this.route.queryParamMap.subscribe(params => {
            this.source = params.get('source');
            if (this.source === 'template') {
              if (this.copyId > 0 && this.copyId != null) {
                this._implementService.GetImplementDetails(this.copyId).subscribe(res => {
                  this.selectedCustomer = res.CustomerId;
                  this._equipmentService.getJobsiteList(this.selectedCustomer).subscribe(re => {
                    console.log(re)
                    this.jobsiteList = re; //TT-9863 
                    this.selectedJobsite = res.JobsiteId; //TT-9863
                    this.equipmentOrInventory = 3;
                    this.callGetImplementsInInventory();
                  });
                });
              }
            }
          });
          this._equipmentService.getJobsiteList(this.destinationCustomer).subscribe(r => {
            this.destinationjobsiteList = r;
            this.destinationJobsite = res.JobsiteId;
            this.destinationImplement = this.routeImplementId;
            this.loadImplementTypes();
          });

        })
      }
    });
    //console.log("this.data", this.data, "this._router.url", this._router.url)
  }


  LoadImplementTypes_() {
    this._implementDetailService.GetImplementTypes().subscribe(res => {
      console.log("res", res)
      this.implementTypeList = res;
    })
  }

  loadImplementTypes() {

    this._fecrService.getImplementTypeList().subscribe(r => {

      let arr = []

      if (this.destinationCustomer != null) {
        this.destinationImplementTypsList = r;

        if (this.routeImplementTypeId != null && this.routeImplementTypeId > 0) {
          this.destinationImplementType = this.routeImplementTypeId;
        }
      }
    });
  }

  loadImplementsList() {
    this._fecrService.GetImplementsAvailable().subscribe(res => {
      this.destinationimplementList = res;
      this.CopydestinationimplementList = res;
    })
  }
  onSelectImplementTypeDestinantion() {
    this.destinationimplementList = this.CopydestinationimplementList;
    console.log("destinationImplementType", this.destinationImplementType, this.destinationimplementList)
    if (this.destinationImplementType == null)
      return

    else {
      this.destinationimplementList = this.destinationimplementList.filter(x => x.Id == this.destinationImplementType);
    }

  }
  /////////////////////////////////
  ///handle destination inputs////
  /////////////////////////////////

  // Show the list of Jobsites for the destination customer.
  loadJobsitesForCustomerDestination() {
    if (this.destinationCustomer == null)
      return;
    this.destinationJobsite = null;
    this.destinationjobsiteList = [];
    this.destinationEquipment = null;
    this.destinationequipmentList = [];
    this._equipmentService.getJobsiteList(this.destinationCustomer).subscribe(r => {
      this.destinationjobsiteList = r;
    });
    this.loadImplementTypes();
  }

  loadEquipmentForJobsiteDestination() {
    if (this.destinationJobsite == null)
      return;
    this._equipmentService.getEquipmentList(this.destinationJobsite).subscribe(r => {
      this.destinationequipmentList = r;
    });
  }

  createInInventoryDestination() {


    // Only proceed if the jobsite is selected.
    if (this.destinationJobsite == null) {
      return;
    }
    if (this.destinationequipmentOrInventory == 1)
      this.destEquipment = this.destinationEquipment;
    else if (this.destinationequipmentOrInventory == 3)
      this.destEquipment = 0;
    else
      this.destEquipment = 0;
  }

  onSelectEquipmentDestinantion() {
    if (this.destinationEquipment != null) {
      //this.loadImplementsForEquipment();
      this.destEquipment = this.destinationEquipment;
      console.log("this.selectedEquipment, this.destEquipment", this.selectedEquipment, this.destEquipment);
      //check destination equipment model
      this._implementService.GetModelDiffMessage(this.selectedEquipment, this.destinationEquipment).subscribe(r => {
        console.log("r", r)
        if (r) {
          this.model_match_for_source_desti_eq = r.match;
          this.source_eq_model = r.modelid_source;
          this.desti_eq_model = r.modelid_dest;
          //this.equipmentSMU = r.smu;
          this.dataSource.data.forEach(item => {
            item.equipmentSMUAtSetup = r.smu;
          });
        }
      });
    }

  }


  // loadImplementsForEquipmentDestinantion() {
  //     this._implementService.GetImplementsOnEquipment(this.destinationEquipment).subscribe(r => {
  //         this.destinationimplementList = r;
  //     });
  // }

  /////////////////////////////////
  ///handle Source inputs//////////
  /////////////////////////////////

  // Show the list of Jobsites for the selected customer.
  // loadJobsitesForCustomer() {
  //     if (this.selectedCustomer == null)
  //         return;
  //     this.selectedJobsite = null;
  //     this.jobsiteList = [];
  //     this.selectedEquipment = null;
  //     this.equipmentList = [];
  //     this._equipmentService.getJobsiteList(this.selectedCustomer).subscribe(r => {
  //         this.jobsiteList = r;
  //     });
  // }
  loadJobsitesForCustomer() {

    this.selectedJobsite = null;
    this.jobsiteList = [];
    this.equipmentList = [];
    this.dataSource.data = [];
    this.MultipleComponentsInfo = [];



    this.cdr.detectChanges();


    if (this.selectedCustomer == null) {
      return;
    }


    this._equipmentService.getJobsiteList(this.selectedCustomer).subscribe(jobSites => {
      this.jobsiteList = jobSites;


      if (this.equipmentOrInventory == 3) {
        this.loadImplementsAfterCustomerChange();
      }
    });
  }



  loadImplementsAfterCustomerChange() {

    this.implementList = [];

    if (!this.selectedJobsite) {
      return;
    }


    this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(implementData => {
      console.log("GetImplementsInInventory", implementData);

      if (implementData.length > 0) {
        this.implementList = implementData.filter(x => x.IsTemplate);
      } else {
        this.implementList = [];
      }

      this.loadTableOfImplementsForCopy();
    });
  }



  // If the implement is selected as being on an equipment, 
  // show the list of equipment for that jobsite.
  // loadEquipmentForJobsite() {
  //     if (this.selectedJobsite == null)
  //         return;
  //     this._equipmentService.getEquipmentList(this.selectedJobsite).subscribe(r => {
  //         this.equipmentList = r;
  //     });
  // }
  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null) {
      return;
    }

    this._equipmentService.getEquipmentList(this.selectedJobsite).subscribe(r => {
      this.equipmentList = r;

      // If "Template" is selected and customer is selected, call the API
      if (this.equipmentOrInventory == 3 && this.selectedCustomer) {
        this.callGetImplementsInInventory();
      }
      else if (this.equipmentOrInventory == 2 && this.selectedJobsite)
        this.createInInventory();
    });
  }
  callGetImplementsInInventory() {
    this.implementList = []; 

    if (!this.selectedJobsite) {
      return;
    }

    
    this.cdr.detectChanges();

    
    this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(implementData => {
      console.log("GetImplementsInInventory", implementData);
      if (implementData.length > 0) {
        this.implementList = implementData.filter(x => x.IsTemplate);
      } else {
        this.implementList = [];
      }

      
      this.cdr.detectChanges();

      this.loadTableOfImplementsForCopy();
    });
  }




  // Load implements for the selected equipment.
  onSelectEquipment() {
    if (this.selectedEquipment != null) {
      this.loadImplementsForEquipment();

      if (this.destinationEquipment != null) {



        //check destination equipment model
        this._implementService.GetModelDiffMessage(this.selectedEquipment, this.destinationEquipment).subscribe(r => {
          console.log("r", r)

          if (r) {
            this.model_match_for_source_desti_eq = r.match;
            this.source_eq_model = r.modelid_source;
            this.desti_eq_model = r.modelid_dest;
          }

        });
      }
    }
  }

  // Implement is in inventory.
  // createInInventory() {
  //     this.MultipleComponentsInfo=[];
  //     if (this.equipmentOrInventory == 2) {
  //         // Only proceed if the jobsite is selected.
  //         if (this.selectedJobsite == null) {
  //             return;
  //         }

  //         this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
  //             console.log("GetImplementsInInventory", r)

  //             if (r.length > 0) {
  //                 this.implementList = r.filter(x => x.IsTemplate == false);
  //             }
  //             this.loadTableOfImplementsForCopy();
  //         });
  //     } else if (this.equipmentOrInventory == 3) {
  //         // Only proceed if the jobsite is selected. 
  //         if (this.selectedJobsite == null) {
  //             return;
  //         }

  //         this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
  //             console.log("GetImplementsInInventory", r)
  //             if (r.length > 0) {
  //                 this.implementList = r.filter(x => x.IsTemplate == true);
  //             }
  //             this.loadTableOfImplementsForCopy();
  //         });
  //     }
  //     else {
  //         this.loadImplementsForEquipment()
  //     }
  // }
  createInInventory() {
    this.MultipleComponentsInfo = [];
    this.implementList = [];  

    if (this.selectedCustomer == null || this.selectedJobsite == null) {
      return;
    }

    if (this.equipmentOrInventory == 2) {
      this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
        console.log("GetImplementsInInventory", r);
        if (r.length > 0) {
          this.implementList = r.filter(x => !x.IsTemplate);
        }
        this.loadTableOfImplementsForCopy();
      });
    } else if (this.equipmentOrInventory == 3) {
      if (this.selectedJobsite) {
        this.callGetImplementsInInventory();
      }
    } else {
      this.loadImplementsForEquipment();
    }
  }



  // Gets the list of implements that are currently loaded on the selected equipment.
  loadImplementsForEquipment() {
    this._implementService.GetImplementsOnEquipment(this.selectedEquipment).subscribe(r => {
      console.log("GetImplementsOnEquipment", r)
      this.implementList = r;
      this.loadTableOfImplementsForCopy();
    });
  }




  // Load the table of implements available to be copied.
  loadTableOfImplementsForCopy() {
    var newList: ImplementToCopy[] = [];
    console.log("implementList", this.implementList)

    for (var i = 0; i < this.implementList.length; i++) {
      var newImplement: ImplementToCopy = {
        //selectImplement: false,
        selectImplement: this.source === 'template' ? this.implementList[i].Id === this.copyId : false,
        implementId: this.implementList[i].Id,
        implementTypeAndSerial: this.implementList[i].Name,
        newSerialNo: "",
        setupDate: this.source === 'template' ? this.implementList[i].SetupDate : null,
        //setupDate: null,
        implementHoursAtSetup: 0,
        equipmentSMUAtSetup: 0,
        status: 0,
        budget_hours: this.implementList[i].Budget_Hours,
        Purchased_Cost: 0
      }

      newList.push(newImplement);
    }
    console.log("newList", newList)

    this.dataSource.data = newList;

    if (this.source === 'template') {
      const selectedImplements = newList.filter(x => x.selectImplement);
      selectedImplements.forEach(implement => {
        implement.selectImplement = false;
        this.CheckImplementSource(implement);
        implement.selectImplement = true;
      });
    }
  }



  validateNewSerialNo(newSerialNo: string) {
    if (newSerialNo == null || newSerialNo.trim().length == 0) {
      return false;
    }
    return true;
  }

  validateSetupDate(setupDate: string) {
    if (setupDate == null) {
      return false;
    }
    return true;
  }

  validateImplementHoursAtSetup(implementSetupHours) {
    if (implementSetupHours == null || (implementSetupHours === "") || isNaN(implementSetupHours) || implementSetupHours < 0) {
      return false;
    }
    return true;
  }

  validateBudgetHoursAtSetup(budget_hours) {
    if (budget_hours == null || (budget_hours === "") || isNaN(budget_hours) || budget_hours < 0) {
      return false;
    }
    return true;
  }

  validateEquipmentSMU(smu) {
    if (smu == null || (smu == "") || smu < 0) {
      return false;
    } if (smu == 0) {
      return true;
    } else {
      return true;
    }

  }

  // Exit modal by pressing Accept
  onConfirmClick() {
    console.log("this.dataSource.data.length", this.dataSource.data)

    if (this.destinationequipmentOrInventory == 3) {
      let count = 0;
      this.dataSource.data.map(x => {
        if (x.selectImplement == true) {
          count = count + 1;
        }
      })
      if (count > 1) {
        this.toastr.error("Please select only one Implement.");
        return;

      } if (this.destinationImplement == null || this.destinationImplement == 0) {
        this.toastr.error("Please select exisiting Implement");
        return;

      }
      if (this.dataSource.data.length == 0) {
        this.toastr.error("Please select implement to copy from");
        return;
      }

      else {
        this.dataSource.data
          .filter(x => x.selectImplement)
          .forEach(implement => {

            let param = new CopyImplmentVM();
            param.SourcesImplementId = implement.implementId;
            param.ExistingImplementId = this.destinationImplement;
            //param.selectedcomponentList = this.componentList;
            param.selectedcomponentList = this.MultipleComponentsInfo.find(C => C.implementId == implement.implementId).componnetList;
            param.selectedImplemetID = this.selectedImplementId;
            param.IsSchematicUsedLink = this.IsSchematicUsedLink == 1;

            this._implementService
              .CreateCopyToExisitingImplementAdvanced(param)
              .subscribe((res: any) => {

                if (res) {
                  implement.status = 1;
                  implement.selectImplement = false;

                  this.toastr.success("Successfully Copied the Implement");

                  if (this.source === 'template') {
                    this.LoadComponentsAndObservationPoint();
                  }
                } else {
                  this.toastr.error(this.pageErrors.ERROR_SAVING_EXISIING_IMPLEMENT);
                }
              });
          });

      }
    }
    else {
      for (var i = 0; i < this.dataSource.data.length; i++) {
        var implement = this.dataSource.data[i];
        if (implement.selectImplement) {
          var isNewSerialNoEntered = this.validateNewSerialNo(implement.newSerialNo);
          var isSetupDateEntered = this.validateSetupDate(implement.setupDate);
          var isImplementSetupHoursEntered = this.validateImplementHoursAtSetup(implement.implementHoursAtSetup);
          var isBudgetHoursEntered = this.validateBudgetHoursAtSetup(implement.budget_hours);

          if (!isNewSerialNoEntered) {
            this.toastr.error("Please enter the serial number.");
            break;
          }

          if (!isSetupDateEntered) {
            this.toastr.error("Please enter the setup date.");
            break;
          }

          if (!isImplementSetupHoursEntered) {
            this.toastr.error("Please enter the implement setup hours.");
            break;
          }

          if (!isBudgetHoursEntered) {
            this.toastr.error("Please enter the Budget setup hours.");
            break;
          }

          if (this.destEquipment > 0) {
            console.log("SMU", implement.equipmentSMUAtSetup)
            var isEquipmentSMUEntered = this.validateEquipmentSMU(implement.equipmentSMUAtSetup);
            if (!isEquipmentSMUEntered) {
              if (implement.equipmentSMUAtSetup == 0) {

              } else {
                this.toastr.error("Please enter the equipment SMU at setup.");
              }
            }
          }
          this.validateAndCopyImplement(implement);
        }
      }
    }
  }

  validateAndCopyImplement(c) {

    console.log("c", c)
    var setupDateParts: string;
    if (c.setupDate != null) {
      // Convert the setupDate string to a Date object
      var setupDateObj = new Date(c.setupDate);

      // Check if the conversion was successful
      if (!isNaN(setupDateObj.getTime())) {
        // Extract date components
        setupDateParts = setupDateObj.getDate() + "/" + (setupDateObj.getMonth() + 1) + "/" + setupDateObj.getFullYear();
      } else {
        // Handle the case where the date conversion failed
        this.toastr.error("Invalid date format: " + c.setupDate);
        //this.toastr.error("Please enter the equipment SMU at setup.");
        c.status = 0; // Or handle the error in another way
      }
    } else {
      c.status = 0;
    }
    //console.log(setupDateParts);

    // Validate the serial number first and check that it is not being used elsewhere.
    this._implementService.ValidateImplementSerial(0, c.newSerialNo).subscribe(r => {
      if (!r) {
        this.toastr.error(this.pageErrors.ERROR_SERIALNO_VALIDATION_FAILED);
        c.newSerialNo = "";
        c.status = 0;
      } else {
        // Only process if both the existing implement and serial number are entered.
        if (c.selectImplement && c.implementId > 0 && c.setupDate != null && c.newSerialNo.length > 0) {
          var iDestinationEquipment = 0;
          if (this.destinationEquipment != null) {
            iDestinationEquipment = this.destinationEquipment;
          }

          let param = new CopyImplmentVM();

          param.ExistingImplementId = c.implementId;
          param.newImplementSerialNo = c.newSerialNo;
          param.equipmentId = iDestinationEquipment;
          param.jobsiteId = this.destinationJobsite;
          param.setupDate = setupDateParts;
          param.implementHoursAtSetup = c.implementHoursAtSetup;
          param.equipmentSMUAtSetup = c.equipmentSMUAtSetup;
          param.hours = c.budget_hours;

          param.selectedcomponentList = this.MultipleComponentsInfo.find(x => x.implementId == c.implementId).componnetList;

          param.isCopyToTemplate = this.destinationequipmentOrInventory == 4 ? true : false;
          param.selectedImpTypeId = (this.destinationequipmentOrInventory == 4 && this.equipmentOrInventory == 3) ? c.DestinationTemplateImplementTypeId : 0;
          param.isCopyTemplateToTemplate = (this.destinationequipmentOrInventory == 4 && this.equipmentOrInventory == 3) ? true : false;
          param.IsSchematicUsedLink = this.destinationequipmentOrInventory != 4 ? this.IsSchematicUsedLink == 1 ? true : false : true;

          //console.log("New Daqta_____", param);
          this._implementService.CreateCopyBasedOnExistingImplementAdvanced(param).subscribe((r2: any) => {
            if (r2 > 0) {
              c.status = 1;
              c.selectImplement = false;
              //this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
              this.toastr.success("Successfully Copied Implement");
              var params1 = this.createImplementDetailParams();
              params1.Details.Id = r2//c.implementId;
              params1.Details.ImplementHoursAtSetup = c.implementHoursAtSetup;
              params1.Details.SetupDate = setupDateParts;
              params1.Details.purchaseCost = c.Purchased_Cost;
              params1.Details.EquipmentSMUAtSetup = c.equipmentSMUAtSetup
              if (this.destinationequipmentOrInventory == 1) {
                params1.EquipmentId = this.destinationEquipment;
                // params1.Details.EquipmentSMUAtSetup = c.equipmentSMUAtSetup
              }
              this._implementService.CreateImplementSetupEvent(params1).subscribe(r => {
                if (r < 0) {
                  this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
                }
              });
            } else {
              this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
              c.status = -1;
            }
          });
        } else {
          this.toastr.error(this.pageErrors.ERROR_SAVING_CHANGES);
          c.status = 0;
        }


      }
    });



  }

  selectedImplementId: number;
  selectedImplementName: string;

  displayedColumnsComponent = [];
  CheckImplementSource(imp: ImplementToCopy) {
    console.log("impl__Before", imp)
    let selectedval = imp;

    if (selectedval.selectImplement == false) {
      console.log("impl__TRUE", imp)


      this.selectedImplementId = imp.implementId;
      this.selectedImplementName = imp.implementTypeAndSerial;
      if (this.MultipleComponentsInfo != null && this.MultipleComponentsInfo.length > 0) {
        if (this.MultipleComponentsInfo.find(x => x.implementId != imp.implementId)) {
          this.LoadComponentsAndObservationPoint();
          this.dataSource.data.map(x => {
            if (imp.selectImplement == true) {
              if (x.implementId != selectedval.implementId) {
                x.selectImplement = false;
              }
            } else {
              //x.selectImplement=false;
            }
          })
        }


      } else {
        this.LoadComponentsAndObservationPoint();

      }
    } else {
      this.MultipleComponentsInfo = this.MultipleComponentsInfo.filter(x => x.implementId != imp.implementId);


    }


    //   if(imp.selectImplement==true){

    //     this.LoadComponentsAndObservationPoint();
    //     this.dataSource.data.map(x=>{
    //       if(imp.selectImplement==true){
    //         if(x.implementId!=imp.implementId){
    //           x.selectImplement=false;
    //         }
    //       }else{
    //         x.selectImplement=false;
    //       }
    //     })
    //   }

  }

  CheckComponentSource(comp: CopyComponentListVM, imp: number) {
    let compList = this.MultipleComponentsInfo.find(x => x.implementId == imp).componnetList;
    if (!comp.SelectedComp) {
      console.log("IF COMP", comp)


      compList.map(x => {
        if (x.ComponentId == comp.ComponentId) {
          x.ObsList.map(y => {
            y.SelectedObs = true;
          })
        }
      })
    } else {
      console.log("ELSE COMP", comp)
      compList.map(x => {
        if (x.ComponentId == comp.ComponentId) {
          x.ObsList.map(y => {
            y.SelectedObs = false;
          })
        }
      })
    }
  }

  CheckObsPointSource(obs: CopyObservationListVM) {
    console.log("obs", obs)

  }

  // isCopyButtonDisabled(): boolean {
  //   const value = !this.componentList?.some(comp =>
  //     comp.SelectedComp === true && comp.DisableCheckbox === false
  //   );
  //   console.log("isCopyButtonDisabled", value);
  //   return value;
  // }

  isCopyButtonDisabled(): boolean {
    const hasComponentToCopy = this.componentList?.some(comp =>
      comp.SelectedComp && !comp.DisableCheckbox
    );

    const hasObsToCopy = this.componentList?.some(comp =>
      comp.ObsList?.some(obs => obs.SelectedObs && !obs.DisableCheckbox)
    );

    const result = !(hasComponentToCopy || hasObsToCopy);
    //console.log("isCopyButtonDisabled", result);
    return result;
  }

  LoadComponentsAndObservationPoint() {
    this.MultipleComponentsInfo = [];
    if (this.source === 'template') {

      // Step 1: Get the copied component + obs list from the route implement
      this._implementService.GETComponentsAndObsPoints(this.routeImplementId).subscribe(copiedResult => {
        console.log("Fetched components for route implement:", copiedResult);
        const copiedNamesSet = new Set(
          copiedResult.map(x => x.ComponentName?.trim().toLowerCase())
        );

        // Map copied obs names per component
        const copiedObsByName: { [key: string]: string[] } = {};

        const copiedIdentifiedCompNameSet = new Set(
          copiedResult
            .map(x => x.IdentifiedCompName)
            .filter(n => n != null)
        );
        console.log("copiedIdentifiedCompNameSet ", copiedIdentifiedCompNameSet);

        const copiedCompLocations: { [key: string]: string[] } = {};

        copiedResult.forEach(comp => {
          const compName = comp.ComponentName?.trim().toLowerCase();
          
          copiedCompLocations[compName] = comp.CompLocations?.map(l => l?.trim().toLowerCase()) || [];
          
          copiedObsByName[compName] = comp.ObsList?.map(obs => obs.ObsName?.trim().toLowerCase()) || [];
        });

        this.copiedComponentId = copiedResult.map(x => ({
          ComponentId: x.ComponentId,
          ComponentName: x.ComponentName,
          ObsList: x.ObsList.map(obs => ({
            ObsId: obs.ObsId,
            ObsName: obs.ObsName
          }))
        }));

        // Step 2: Get the current implement's component list
        this._implementService.GETComponentsAndObsPoints(this.selectedImplementId).subscribe(result => {
          console.log("Fetched components for selected implement:", result);
          console.log("Copied Component Names Set:", copiedNamesSet);

          result.forEach(component => {
            const compName = component.ComponentName?.trim().toLowerCase();
            const isComponentCopied = copiedNamesSet.has(compName);
            const name = component.IdentifiedCompName?.trim();
            const hasIdentifiedComp = !!name && !copiedIdentifiedCompNameSet.has(name);
            const copiedLocNames = copiedCompLocations[compName] || [];
            const currentLocNames = component.CompLocations?.map(o => o.trim().toLowerCase()) || [];
            const copiedLocSet = new Set(copiedLocNames);
            const hasNewLocation = currentLocNames.some(name => !copiedLocSet.has(name));

            const copiedObsNames = copiedObsByName[compName] || [];
            const currentObsNames = component.ObsList?.map(o => o.ObsName?.trim().toLowerCase()) || [];

            console.log('hasIdentifiedComp:', hasIdentifiedComp);
            console.log('hasNewLocation:', hasNewLocation);
            console.log('Copied Obs Names:', copiedObsNames);
            console.log('Current Obs Names:', currentObsNames);

            let anyObsNotCopied = false;

            component.ObsList?.forEach(obs => {
              const obsName = obs.ObsName?.trim().toLowerCase();
              const isObsCopied = copiedObsNames.includes(obsName);

              console.log(`-- Obs: ${obsName}, Copied: ${isObsCopied}`);

              obs.SelectedObs = !isObsCopied;
              obs.DisableCheckbox = isObsCopied;

              if (!isObsCopied) {
                anyObsNotCopied = true;
              }
            });

            const hasObs = component.ObsList?.length > 0;

            if (!hasObs && isComponentCopied) {
              // No obs, component copied → disable
              component.SelectedComp = false;
              component.DisableCheckbox = true;
              console.log('Component disabled (no obs + copied):', compName);
            } else if (isComponentCopied && !anyObsNotCopied) {
              // All obs copied → disable component
              component.SelectedComp = false;
              component.DisableCheckbox = true;
              console.log('Component disabled (all obs copied):', compName);
            } else {
              // Some obs not copied or component not copied → enable
              component.SelectedComp = true;
              component.DisableCheckbox = false;
              console.log('Component enabled:', compName);
            }
            if (hasIdentifiedComp || hasNewLocation) {
              component.SelectedComp = true;
              component.DisableCheckbox = false;
            }
          });

          // Step 4: Package for UI
          const parms = new ListOfComponetInfo();
          parms.implementId = this.selectedImplementId;
          parms.ImpSerial = this.selectedImplementName;
          parms.componnetList = result;
          this.MultipleComponentsInfo.push(parms);

          // Step 5: Bind to table
          this.componentList = result;
          this.dataSourceComponentList.data = this.componentList;
          this.displayedColumnsComponent = [
            'SelectedComp', 'ComponentName', 'ComponentTypeName', 'PartNo', 'BudgetLife'
          ];

          console.log('Final Component List:', this.componentList);


        });
      });

    }
    else {
      this._implementService.GETComponentsAndObsPoints(this.selectedImplementId).subscribe(result => {
        //this.componentList = result;
        var parms = new ListOfComponetInfo();
        parms.implementId = this.selectedImplementId;
        parms.ImpSerial = this.selectedImplementName;
        parms.componnetList = result;
        this.MultipleComponentsInfo.push(parms);

        this.dataSourceComponentList.data = this.componentList;
        this.displayedColumnsComponent = ['SelectedComp', 'ComponentName', 'ComponentTypeName', 'PartNo', 'BudgetLife']
      });
    }
  }
  createImplementDetailParams(): SaveImplementDetailParams {
    var details: ImplementDetails = new ImplementDetails();
    details.Id = 0;
    details.ImplementType = 0;
    details.Make = 0;
    details.SerialNo = "";
    details.SetupDate = "";
    details.ImplementHoursAtSetup = 0;
    details.EquipmentSMUAtSetup = 0;

    var params = new SaveImplementDetailParams();
    params.Details = details;
    params.EquipmentId = this.selectedEquipment;
    params.JobsiteId = this.selectedJobsite;

    return params;
  }
}
